/**
 * Türkçe tarih helper'ları — BRANDBOOK §9.2 (O13C Hibrit).
 *
 * formatRelative: Yaşına göre okunabilir göreli ifade.
 *   < 1 dakika → "az önce"
 *   1-59 dakika → "X dakika önce"
 *   1-23 saat → "X saat önce"
 *   < 24h ve dün → "Dün HH:mm"
 *   ≥ 24 saat (aynı yıl) → "27 May"
 *   Önceki yıllar → "27 May 2025"
 *
 * formatAbsolute: Tam tarih "27.05.2026 14:23" (tooltip için).
 */

const MONTH_SHORT_TR = ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'];

function pad(n: number): string {
  return n < 10 ? `0${n}` : String(n);
}

function isYesterday(date: Date, now: Date): boolean {
  const y = new Date(now);
  y.setDate(y.getDate() - 1);
  return date.getFullYear() === y.getFullYear() && date.getMonth() === y.getMonth() && date.getDate() === y.getDate();
}

export function formatAbsolute(input: string | number | Date): string {
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function formatRelative(input: string | number | Date, now: Date = new Date()): string {
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return '';

  const diffMs = now.getTime() - d.getTime();
  const diffMin = Math.floor(diffMs / 60_000);

  if (diffMin < 1) return 'az önce';
  if (diffMin < 60) return `${diffMin} dakika önce`;

  const diffHour = Math.floor(diffMin / 60);
  if (diffHour < 24) return `${diffHour} saat önce`;

  if (isYesterday(d, now)) {
    return `Dün ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  const sameYear = d.getFullYear() === now.getFullYear();
  const monthLabel = MONTH_SHORT_TR[d.getMonth()];
  return sameYear ? `${d.getDate()} ${monthLabel}` : `${d.getDate()} ${monthLabel} ${d.getFullYear()}`;
}
